<template>
  <nxt-core-modal
    :visible="displayWarningDeletion"
    v-loading="loading"
    width="400px"
    :class="['warning-deletion', { '--is-mobile': isMobile }]"
    top="0px"
    @update:visible="close"
  >
    <template #header>{{ $t("profile.payment.warningDeleteTitle") }}</template>
    <span class="warning-deletion__content">
      <details-card-payment :card="card" hidden-after hidden-delete></details-card-payment>
    </span>
    <br />
    <span v-if="isMobile" class="warning-deletion__footer">
      <nxt-core-btn
        class="warning-deletion__footer__left nxt-button nxt-button__light-grey"
        @click="close"
        :disabled="loading"
        :loading="loading"
      >
        {{ $t("base.no") }}
      </nxt-core-btn>
      <nxt-core-btn
        @click="deleteCard"
        :disabled="loading"
        :loading="loading"
        class="nxt-button nxt-button__danger"
      >
        {{ $t("base.delete") }}
      </nxt-core-btn>
    </span>
    <template #footer v-if="!isMobile">
      <span class="warning-deletion__footer">
        <nxt-core-btn
          @click="close"
          :disabled="loading"
          :loading="loading"
          class="warning-deletion__footer__left nxt-button__light-grey nxt-button"
        >
          {{ $t("base.no") }}
        </nxt-core-btn>
        <nxt-core-btn
          @click="deleteCard"
          :disabled="loading"
          :loading="loading"
          class="warning-deletion__footer__right nxt-button nxt-button__danger"
        >
          {{ $t("base.delete") }}
        </nxt-core-btn>
      </span>
    </template>
  </nxt-core-modal>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useDimensionStore, useProfileStore } from "@/stores";
import DetailsCardPayment from "@/components/profile/payment/DetailsCardPayment.vue";

export default {
  name: "DeleteCardPaymentModal",
  components: {
    DetailsCardPayment,
  },
  computed: {
    ...mapState(useDimensionStore, ["isMobile"]),
    ...mapState(useProfileStore, {
      displayWarningDeletion: "isDeletingCardPaymentDisplayed",
      card: "contentCardPayment",
      loading: "isCardInfoLoading",
    }),
    name() {
      return this.data;
    },
  },
  methods: {
    ...mapActions(useProfileStore, ["deleteCardPayment", "unsetDeleteCardPaymentModalDisplayed"]),
    close() {
      this.unsetDeleteCardPaymentModalDisplayed();
    },
    async deleteCard() {
      try {
        await this.deleteCardPayment(this.card.pm_id);
        this.close();
        // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
  },
};
</script>

<style scoped lang="scss">
.warning-deletion {
  &__title {
    text-align: center;
    display: block;
    word-break: break-word;
    font-weight: var(--nxt-font-weight-medium);
    font-size: var(--nxt-font-size-large);
  }
  &__content {
    display: block;
    text-align: start !important;
    margin: 5px;
    font-size: var(--nxt-font-size-medium);
  }
  &__furnitures {
    font-weight: var(--nxt-font-weight-medium);
    text-align: start;
    font-size: var(--nxt-font-size-medium);
  }
  &__footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    @include baseBreakpoint(mobileWithHeight) {
      margin-top: 0;
    }

    &__left {
      margin-right: 15px;

      &.nxt-button__light-grey {
        color: var(--nxt-color-primary);
      }
    }
  }
  &.--is-mobile {
    height: 100%;
  }
}
</style>
